import { ReferralControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";
import { ArchiveMutation } from "../../../hooks/useArchiveState";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveReferral = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new ReferralControllerApi(getConfigObject()).updateReferralArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
